export default __webpack_public_path__ + "static/media/Niramit-MediumItalic.7dbcbe92.ttf";